import React from 'react';

import SubscribeFormContainer from 'containers/forms/SubscribeForm';

import styles from './styles.module.scss';

const Subscription = () => (
	<div className={styles.block}>
		<div className={styles.info}>
			<div className={styles.title}>
				Подпишитесь на рассылку портала «Культура.РФ»
			</div>
			<div className={styles.subtitle}>
				Рассылка не содержит рекламных материалов
			</div>
		</div>
		<div className={styles.form}>
			<SubscribeFormContainer id="footer-subscribe" />
		</div>
	</div>
);

export default Subscription;
